// extracted by mini-css-extract-plugin
export default {"wrapper":"HelpDesk_wrapper__cKf4G","helpdesk":"HelpDesk_helpdesk__OFG9M"};